export enum OverviewAudienceEnum {
    Segments = 'segment',
    AccountLists = 'list'
  }
  